import { render, staticRenderFns } from "./xuzhi.vue?vue&type=template&id=59cf9480&scoped=true&"
import script from "./xuzhi.vue?vue&type=script&lang=js&"
export * from "./xuzhi.vue?vue&type=script&lang=js&"
import style0 from "./xuzhi.vue?vue&type=style&index=0&id=59cf9480&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "59cf9480",
  null
  
)

export default component.exports